export const DIVIDEND_PER_SHARE_FRACTION_DIGITS = 4;
export const DIVIDEND_AMOUNT_FRACTION_DIGITS = 2;

export const formatDividendPerShare = (value: number): string =>
  value.toLocaleString('en-US', { maximumFractionDigits: DIVIDEND_PER_SHARE_FRACTION_DIGITS });

export const formatDividendAmount = (value: number): string =>
  value.toLocaleString('en-US', { maximumFractionDigits: DIVIDEND_AMOUNT_FRACTION_DIGITS });
